import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable()
export class LgpdService {
  constructor(private httpClient: HttpClient) {}

  verificarTermoUsuario(cpf, siglaSistema, siglaTermo): Observable<any> {
    return this.httpClient.get(
      `${environment.urlApiLGPD}/api/lgpd/termo/usuario/${cpf}/${siglaSistema}/${siglaTermo}`
    );
  }

  aceitarTermoUsuario(obj: any): Observable<any> {
    const json = JSON.stringify(obj);
    return this.httpClient.post(
      `${environment.urlApiLGPD}/api/lgpd/termo/usuario`,
      json,
      httpOptions
    );
  }

  carregarTermoSistema(siglaSistema, siglaTermo): Observable<any> {
    return this.httpClient.get(
      `${environment.urlApiLGPD}/api/lgpd/termo/sistema/${siglaSistema}/${siglaTermo}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/lgpd.service.ts